import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
}

const getOpeningHoursWeekDays = ({ messages }) => {
  return [
    { label: messages.commonWeekDayMonday, value: 'monday' },
    { label: messages.commonWeekDayTuesday, value: 'tuesday' },
    { label: messages.commonWeekDayWednesday, value: 'wednesday' },
    { label: messages.commonWeekDayThursday, value: 'thursday' },
    { label: messages.commonWeekDayFriday, value: 'friday' },
    { label: messages.commonWeekDaySaturday, value: 'saturday' },
    { label: messages.commonWeekDaySunday, value: 'sunday' }
  ];
};

export default getOpeningHoursWeekDays;
